import type { CSSProperties, FC } from 'react';
import React from 'react';

import { BodyL } from 'components/basic/Typography';

import s from './Tag.module.scss';

interface Props {
  text: string;
  measure?: string;
  color: 'brand' | 'red' | 'warm_2' | 'warm_1' | 'yellow' | 'awake';
}

const Tag: FC<Props> = ({ text, measure, color }) => {
  return (
    <div
      className={s.tag}
      style={
        {
          '--text-base': `var(--${color})`,
        } as CSSProperties
      }
    >
      <BodyL>{text}</BodyL>
      {measure && <BodyL className={s.measure}>{measure}</BodyL>}
    </div>
  );
};

export default Tag;
